import { CommonPrivacy } from 'features/common'

export enum WorkflowDialogName {
  ExtensionPackages = 'ExtensionPackages'
}

export enum WorkflowsExecutionStatus {
  Unexecuted = 'Unexecuted',
  Running = 'Running',
  Done = 'Done'
}

export enum CrossHair {
  Note = 'note',
  NoteAI = 'noteai'
}

export enum DoType {
  Number = 'number',
  String = 'string'
}

export enum WorkflowNodeStatus {
  Outdated = 'Outdated',
  Deprecated = 'Deprecated',
  Removed = 'Removed',
  Unexecuted = 'Unexecuted',
  Unexecutable = 'Unexecutable',
  Running = 'Running',
  Success = 'Success',
  Failure = 'Failure'
}

export enum LogMessageType {
  Info = 'Info',
  Warning = 'Warning',
  Success = 'Success',
  Error = 'Error',
  Execution = 'Execution'
}

export enum WorkflowResultsTabs {
  Messages = 0,
  Data = 1,
  Map = 2,
  SQL = 3
}

export enum WorkflowPrivacy {
  Private = CommonPrivacy.Private,
  Shared = CommonPrivacy.Shared
}

export enum WorkflowsFieldToOrderBy {
  Title = 'title',
  UpdatedAt = 'updated_at'
}

export enum WorkflowNodeActions {
  Update = 'update',
  Delete = 'delete'
}

export enum WorkflowProcedureStatus {
  Outdated = 'outdated',
  Exists = 'exists',
  Missing = 'missing'
}

export enum WorkflowExtensionPackageAction {
  Show = 'show',
  Details = 'details',
  Update = 'update',
  ShowInPanel = 'showInPanel',
  Uninstall = 'uninstall'
}

export enum WorkflowTemplatesType {
  New = 'new',
  FromTemplate = 'fromTemplate'
}

export enum SchemaStatus {
  Pending = 'pending',
  Failed = 'failed',
  Loaded = 'loaded',
  NotConfigured = 'notConfigured'
}

export const WorkflowErrorCodes = {
  ControlledCancel: 'CONTROLLED_CANCEL',
  ScheduleCleanUpMissingPermissions: 'SCHEDULE_CLEAN_UP_MISSING_PERMISSIONS'
}

export enum WorkflowsPermissionsType {
  All = 'all',
  Mine = 'mine',
  Shared = 'shared'
}
